import React from "react";
import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

export function FadeUp({ children, delay = 0, className = "", once = true, y = 24 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: easing }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

/**
 * Masked line-by-line reveal for hero headings.
 * Splits `text` on newlines; each line masks in from below.
 */
export function LineReveal({ text, className = "", stagger = 0.09, delay = 0.15 }) {
  const lines = String(text).split("\n");
  return (
    <span className={`inline-block ${className}`}>
      {lines.map((line, i) => (
        <span
          key={i}
          className="block overflow-hidden leading-[0.95]"
          style={{ paddingBottom: "0.06em" }}
        >
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.05,
              ease: easing,
              delay: delay + i * stagger,
            }}
          >
            {line || "\u00A0"}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function WordCascade({ text, delay = 0, className = "" }) {
  const words = String(text).split(" ");
  return (
    <span className={className}>
      {words.map((w, i) => (
        <span key={i} className="inline-block overflow-hidden">
          <motion.span
            className="inline-block"
            initial={{ y: "110%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            transition={{
              duration: 0.8,
              ease: easing,
              delay: delay + i * 0.04,
            }}
          >
            {w}&nbsp;
          </motion.span>
        </span>
      ))}
    </span>
  );
}
